module.exports = __webpack_public_path__ + "img/workBench3.57a68811.png";